const state = {
  amount: null
}
const getters = {
  getAmount () {
    return state.amount
  }
}
const mutations = {
  setAmount (state, value) {
    state.amount = value
  }
}
const actions = {
  clearAmount () {
    state.amount = null
  },
  sendAnalytics (context, param) {
    const analyticsEnabled = window.dataLayer || context.rootGetters['getThirdpartyAnalytics']
    if (analyticsEnabled) {
      let isFirstDeposit = context.rootGetters['getNumberOfDeposits'] === 0 ? 'first_deposit' : 'deposit'
      let isFirstWithdrawal = context.rootGetters['getNumberOfWithdrawals'] === 0 ? 'first_withdrawal' : 'withdrawal'
      let status = (param === 'confirm') ? 'confirm' : ((param === 'failed') ? 'failed' : '')
      let transactionType = context.rootGetters['payments/transactionType']
      let transaction = (transactionType === 'deposit') ? isFirstDeposit : ((transactionType === 'withdrawal') ? isFirstWithdrawal : '')
      const amount = context.getters['getAmount']
      let dataObj = {
        'event': `${transaction}_${status}`,
        'gaEventCategory': transaction,
        'gaEventAction': `${transaction}_${status}`,
        'accountId': localStorage.getItem('customer'),
        'stake': amount,
        'currency': 'USD'
      }
      let xtremeObj = {
        'param1': 'event',
        'param2': transaction + '_completed_cs',
        'param3': {
          'status': `${transaction} ${status}`,
          'amount': amount ? parseInt(amount) : '',
          'currency': 'USD'
        }
      }
      context.dispatch('clearAmount')
      context.dispatch('analyticsHandler', {'event': dataObj, 'xtremeObj': xtremeObj}, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/payments/analytics.js